import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth-context';

function HomeIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M9 21V15C9 14.4696 9.21071 13.9609 9.58579 13.5858C9.96086 13.2107 10.4696 13 11 13H13C13.5304 13 14.0391 13.2107 14.4142 13.5858C14.7893 13.9609 15 14.4696 15 15V21M5 12H3L12 3L21 12H19V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V12Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

function SearchIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M21 21L15 15M3 10C3 10.9193 3.18106 11.8295 3.53284 12.6788C3.88463 13.5281 4.40024 14.2997 5.05025 14.9497C5.70026 15.5998 6.47194 16.1154 7.32122 16.4672C8.1705 16.8189 9.08075 17 10 17C10.9193 17 11.8295 16.8189 12.6788 16.4672C13.5281 16.1154 14.2997 15.5998 14.9497 14.9497C15.5998 14.2997 16.1154 13.5281 16.4672 12.6788C16.8189 11.8295 17 10.9193 17 10C17 9.08075 16.8189 8.1705 16.4672 7.32122C16.1154 6.47194 15.5998 5.70026 14.9497 5.05025C14.2997 4.40024 13.5281 3.88463 12.6788 3.53284C11.8295 3.18106 10.9193 3 10 3C9.08075 3 8.1705 3.18106 7.32122 3.53284C6.47194 3.88463 5.70026 4.40024 5.05025 5.05025C4.40024 5.70026 3.88463 6.47194 3.53284 7.32122C3.18106 8.1705 3 9.08075 3 10Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

function TicketsIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M15 5V7M15 11V13M15 17V19M5 5H19C19.5304 5 20.0391 5.21071 20.4142 5.58579C20.7893 5.96086 21 6.46957 21 7V10C20.4696 10 19.9609 10.2107 19.5858 10.5858C19.2107 10.9609 19 11.4696 19 12C19 12.5304 19.2107 13.0391 19.5858 13.4142C19.9609 13.7893 20.4696 14 21 14V17C21 17.5304 20.7893 18.0391 20.4142 18.4142C20.0391 18.7893 19.5304 19 19 19H5C4.46957 19 3.96086 18.7893 3.58579 18.4142C3.21071 18.0391 3 17.5304 3 17V14C3.53043 14 4.03914 13.7893 4.41421 13.4142C4.78929 13.0391 5 12.5304 5 12C5 11.4696 4.78929 10.9609 4.41421 10.5858C4.03914 10.2107 3.53043 10 3 10V7C3 6.46957 3.21071 5.96086 3.58579 5.58579C3.96086 5.21071 4.46957 5 5 5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

function LikesIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M19.4993 12.5721L11.9993 20.0001L4.49932 12.5721C4.00463 12.0907 3.61497 11.5121 3.35487 10.8727C3.09478 10.2333 2.96989 9.54701 2.98806 8.85699C3.00624 8.16697 3.16709 7.48819 3.46048 6.86339C3.75388 6.23859 4.17346 5.68131 4.69281 5.22663C5.21216 4.77196 5.82003 4.42974 6.47814 4.22154C7.13624 4.01333 7.83033 3.94364 8.51669 4.01686C9.20306 4.09007 9.86682 4.30461 10.4662 4.64696C11.0656 4.98931 11.5876 5.45205 11.9993 6.00605C12.4129 5.45608 12.9355 4.99738 13.5344 4.65866C14.1334 4.31994 14.7958 4.1085 15.4803 4.03757C16.1647 3.96665 16.8564 4.03775 17.5121 4.24645C18.1678 4.45514 18.7734 4.79693 19.2909 5.25042C19.8084 5.70391 20.2268 6.25934 20.5197 6.88195C20.8127 7.50456 20.9741 8.18094 20.9936 8.86876C21.0132 9.55659 20.8906 10.241 20.6335 10.8793C20.3763 11.5176 19.9902 12.0959 19.4993 12.5781" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

const NAV_ITEMS = [
    { to: '/', label: 'Home', icon: HomeIcon, end: true, requiresAuth: false },
    { to: '/search', label: 'Search', icon: SearchIcon, end: false, requiresAuth: false },
    { to: '/profile/tickets', label: 'Tickets', icon: TicketsIcon, end: false, requiresAuth: true },
    { to: '/profile/likes', label: 'Likes', icon: LikesIcon, end: false, requiresAuth: true },
];

export default function MobileBottomNav() {
    const { isAuthenticated } = useAuth();
    const navigate = useNavigate();

    return (
        <nav
            data-hide-on-keyboard
            className="sm:hidden fixed inset-x-3 z-50 transition-colors"
            style={{ bottom: 'calc(0.75rem + env(safe-area-inset-bottom))' }}
        >
            <div className="flex h-16 items-center justify-around rounded-full bg-white/95 px-2 ring-1 ring-black/[0.06] shadow-[0_10px_40px_-12px_rgba(0,0,0,0.3)] dark:bg-[#121212]/95 dark:ring-white/10">
                {NAV_ITEMS.map(({ to, label, icon: Icon, end, requiresAuth }) => (
                    <NavLink
                        key={to}
                        to={to}
                        end={end}
                        aria-label={label}
                        onClick={(e) => {
                            if (requiresAuth && !isAuthenticated) {
                                e.preventDefault();
                                navigate('/login');
                            }
                        }}
                        className={({ isActive }) =>
                            `flex flex-1 items-center justify-center transition-colors ${
                                isActive ? 'text-white dark:text-nightBg' : 'text-grey50 dark:text-nightMuted'
                            }`
                        }
                    >
                        {({ isActive }) => (
                            <span className={`flex h-12 items-center justify-center gap-2 rounded-full transition-all ${isActive ? 'bg-grey10 px-4 dark:bg-nightAccent' : 'w-12'}`}>
                                <Icon />
                                {isActive && <span className="text-[13px] font-semibold">{label}</span>}
                            </span>
                        )}
                    </NavLink>
                ))}
            </div>
        </nav>
    );
}
